'use client';
import { useState } from 'react';

import Card, { CardContent } from '@/components/@base/card';
import Container from '@/components/@base/container';
import { Heading, Text } from '@/components/@base/typography';
import { HEADING_TYPE } from '@/components/@base/typography/heading/type';
import { TEXT_TYPE } from '@/components/@base/typography/text/type';

import { DATA_CY_ABOUT_HISTORY } from '@/constant/cypress';
import { pageLevelLocalization } from '@/constant/localization';

import HistoryInfo from './historyInfo';
import HistorySlider from './historySlider';
import { historyYears } from '../services/type';

export default function History() {
  const [currentSlide, setCurrentSlide] = useState<number | number[]>(historyYears[1403]);
  const {
    content: {
      aboutUs: { history: historyLocalization },
    },
  } = pageLevelLocalization;

  return (
    <Container
      data-cy={DATA_CY_ABOUT_HISTORY}
      center
      className='z-50 max-w-[986px] flex-1 flex-col gap-8 *:w-full md:mx-auto'
    >
      <Container className='w-auto! rounded-[32px] border-[3px] border-white bg-linear-to-l from-[#FFDAA2] via-[#FFF3E0] to-[#FFE6C1] px-6 py-3 shadow-[0px_5px_25px_0px_#FF6B0114]'>
        <Text
          type={TEXT_TYPE.SPAN}
          className='text-sm leading-5 font-light tracking-tighter text-[#BC8757]'
        >
          {historyLocalization.title.more_than}
          <Text
            type={TEXT_TYPE.SPAN}
            className='text-sm leading-5 font-medium tracking-tighter text-[#F39900]'
          >
            {historyLocalization.title.three_thousand_products}
          </Text>
          {historyLocalization.title.for_you}
        </Text>
      </Container>
      <Heading
        type={HEADING_TYPE.H1}
        className='text-center text-[26px] leading-9 font-medium tracking-[-1px] text-[#424244]'
      >
        {historyLocalization.zhaket_history}
      </Heading>
      <article>
        <Card noBorder className='z-50 mx-4 mb-6 flex bg-white'>
          <CardContent className='flex flex-1 flex-row gap-10 pb-16 md:flex-col md:px-16 md:pt-20'>
            <HistorySlider onChange={(value) => setCurrentSlide(value)} />
            <HistoryInfo currentSlide={currentSlide} />
          </CardContent>
        </Card>
      </article>
    </Container>
  );
}
